import { Injectable, EventEmitter, ElementRef } from '@angular/core';
import {
  AbstractControl,
  Form,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from './api.service';
import { StorageService } from './storage.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DeviceDetectorService } from 'ngx-device-detector';
import _moment from 'moment';
//import { AuditLogger } from '../modules/audit-logger';
//import { MatDialog } from '@angular/material/dialog';
import {
  BehaviorSubject,
  Subject,
  audit,
  catchError,
  filter,
  firstValueFrom,
  of,
} from 'rxjs';
//import saveAs from 'file-saver';
//import { RowUpdateService } from './data.service';

//import { Modules } from '../constants/constants';

const moment = _moment;
@Injectable({
  providedIn: 'root'
})
export class CommonService {
  sidbarChange: EventEmitter<boolean> = new EventEmitter();
  headerUpdate: EventEmitter<boolean> = new EventEmitter();
  rowUpdate: EventEmitter<number> = new EventEmitter();
  onEntityChange: EventEmitter<any> = new EventEmitter();
  onEntityListChange: EventEmitter<any> = new EventEmitter();
  private permissionSubject = new Subject<boolean>();
  /*udyamNumber = '^UDYAM-[A-Z]{2}-\\d{2}-\\d{7}$';*/
  udyamNumber = '^UDYAM-MH-\\d{2}-\\d{7}$';
  pincodePattern = '^[4][0-9]{5}$';
  iecCodePattern = '^[1-9]\\d{9}$';
  permission$ = this.permissionSubject.asObservable();
  emailPattern = '^[0-9a-zA-Z][0-9a-zA-Z._%+-]*@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$';

  passwordPattern =
    '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d.*)(?=.*\\W.*)[a-zA-Z0-9\\S]{8,}$';
  taxIdPattern = '^\\d{2}-?\\d{7}$';
  cliaPattern = '^[A-Za-z0-9]{10}$';
  cliaPatternNew = '^[A-Z]{2}\\d{10}$';
  //addressPattern = "^[A-Za-z0-9'\\.\\-\\s\\,\\/]*$";
  //addressPattern = "^[^=+\-@][A-Za-z0-9'.\-\s,\/]*[^&]*$";
  //addressPattern = "^([0-9]|[^=+\\-@])[A-Za-z0-9' .-_%:;!^*{}[]+=,.?@$/#()/\-\s,&\/ ]*$";
  //addressPattern = "^(?!.*&)[A-Za-z0-9'.\-\s,\/]*$";

  addressPattern = "^[^=+\\-@][ -~]*$";
  phonePattern = '^\\d{3}-\\d{4}-\\d{4}$';
  mobilePattern = '^[6-9]\\d{9}$';
  ssnPattern = '^\\d{3}-\\d{2}-\\d{4}$';
  upinPattern = '^[a-zA-Z0-9]{6}$';
  // phonePattern = '^[0-9]*$';
  nameWithHypen = '^[^=+\-@][a-zA-Z- ]+$';
  nameWithHypenCommaSlash = "^[^=+\-@][a-zA-Z0-9'-._,&@#$()/ ]+$";
  masterdescriptionPattern = "^[^=+\\-@][A-Za-z0-9',.\\-\\s,]*$";

  descriptionPattern = "^[A-Za-z0-9',.\\-\\s,]*$";
  grievanceDescription = "^[^=+\-@][\\s\\S]*$";

  enterpriseNamePattern = "^([^0-9=+@&])[\\s\\S]*$";

  city = '^[^=+\-@][a-zA-Z0-9,-._&@#$()/\\.-]*(/[a-zA-Z0-9,-._&@#$()/\\.-]+)?( [a-zA-Z0-9,-._&@#$()/\\./-]+)*$';
  //descriptionPattern = "^[A-Za-z0-9'\\.\\-\\s\\,]*$";
  feePattern = '^(?!^0*$)(?!^0*\\.0*$)^\\d{0,10}(\\.\\d{1,2})?$';
  // feePattern = /^(?!0(\.0*)?$)\d{0,9}(\.?\d{0,2})?$/;
  zipCodePattern = '^[0-9]{5}(?:[0-9]{4})?$';
  numbersPattern = '^[0-9]*$';
  stringWithNumberAndSpacePattern = '[a-zA-Z0-9 ]*$';
  stringWithSpacePattern = '^[a-zA-Z]+( [a-zA-Z]+)*$';// allow single space and only characters
  nameWithSpacePattern = "^[^=+\-@][a-zA-Z'-._,&@#$()/\\-]*(/[a-zA-Z'-._,&@#$()/\\-]+)?( [a-zA-Z'-._,&@#$()/\\/-]+)*$"; // allow single space - , and /
  fileNamePattern = '^[^=+\-@][a-zA-Z0-9]+([._/-][a-zA-Z0-9]+)*$'; // allow single space - , and /
  stringPattern = '^[a-zA-Z]+$';
  stringWithCapital = '^[A-Z]+$'; //allow only capital letters
  alphanumericWithoutSpacePattern = '[a-z0-9]+([a-z0-9]+)*$';
  alphanumericWithoutSpacePattern1 = '[a-zA-Z0-9/]+([a-zA-Z0-9/]+)*$'; //alphanumericWithoutSpacePattern1 allows /
  alphanumericWithSpaceAtMiddlePattern = '^[a-zA-Z0-9]+([ ][a-zA-Z0-9]+)*$';
  stringWithSpaceAtmiddlePattern = '^[a-zA-Z]+([ ][a-zA-Z]+)*$';
  grievanceCode = '^[A-Z]{3}$';
  nameOfOrganisation = "^[a-zA-Z ]*$";
  icdCodePattern = '[A-TV-Z][0-9][0-9AB].?[0-9A-TV-Z]{0,4}';
  diagnosisCodePattern = '^[A-Z0-9.]*$';
  NDCCodePattern = '^\\d{5}-\\d{4}-\\d{2}$';
  npiPattern = '[0-9]{10}';
  numbersAndStringPattern = '^[^=+\-@][a-zA-Z0-9]*$';
  utrPattern = '^[^=+\-@][a- zA-Z0-9-_/ ]+$';
  /*nameWithHypenCommaSlash = '^[a-zA-Z0-9-._,&@#$()/ ]+$';*/
  alphaNumericPattern = /^[a-zA-Z0-9]*$/;
  alphaNumericWithSpacePattern = /^[a-zA-Z0-9\s]*$/;
  alphaNumericWithSpacePattern1 = /^[a-zA-Z0-9\s ]*$/;
  alphaNumericWithSpaceComaPattern = /^[a-zA-Z0-9,\s]+$/;
  alphaNumericWithSpaceSplPattern = /^[A-Za-z0-9\s_.&+-]*$/;
  alphaNumericWithHyphen = /^[a-zA-Z0-9-_]+$/;
  cptCodePattern = '^[A-Za-z0-9]{3,5}$';
  cptModdifierPattern = '^([a-zA-Z0-9]){2}$';
  decimalNumberPatter = '^(?!0+(\\.0+)?$)\\d{0,5}(.\\d{1,2})?$';
  atleastOneDecimal = '^(?:0|[1-9]d+|)?(?:.?d{0,2})?$';
  invoiceAmount = '^\d + (\.\d{ 1, 2 })?$';
  PTAN = '[0-9]{6}';
  tinPattern = '^\\d{3}-\\d{2}-\\d{4}$';
  medicaidNumber = '[0-9]{9}';
  copay = '[0-9]{2}';
  percentageRegex = /^(100|[1-9][0-9]?)%$/;
  //providerSSNPattern: '[0-9]{9}';
  // documentName:'^[A-Z][a-z]{2,50}';
  numberPattern = '^[0-9]{1,11}(?:.[0-9]{1,3})?$';
  numberOnly = '^[0-9]{5}$';  // Update the pattern to validate exactly 5 digits for NIC Master
  gstPercent = '^[0-9]+(\\.[0-9]{1,2})?$'; 
  nonZero = '^(?!(0))[0-9]+$';
  feePercentPattern = /^(100(\.0{1,2})?|[1-9]?\d(\.\d{1,2})?)$/;
  zipCodeNew = '^(d{5}|d{9})?$';
  urlPattern =
    '^(?!mailto:)(?:(?:http|https|ftp)://)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$';

  specialCharactersPattern =
    /^(?:([$&+,:;=?@#|'<>.^*()%!-])(?!.*?\1),)*[$&+,:;=?@#|'<>.^*()%!-]$/;

  
  notAllowedAampersand = '^[^&]*$';

  NotAllowedSpecialCharactersPattern = /^[^$&+,:;=?@#|'<>.^*()%!-]*$/;
  allowspace = '^[a-zA-Z0-9s]*$';
  // DataTable Pagination Icon
  nextPage = 'Next <i class="fa fa-lg fa-angle-right" aria-hidden="true"></i>';
  previousPage =
    '<i class="fa fa-lg fa-angle-left" aria-hidden="true"></i> Previous';
  firstPage =
    '<i class="fa fa-lg fa-angle-double-left" aria-hidden="true"></i>';
  lastPage =
    '<i class="fa fa-lg fa-angle-double-right" aria-hidden="true"></i>';
  
  patientId: any;
  private selectedRecordIndex: number = -1;
  nextPageSelectedRecordIndex: number | undefined = 1;
  currentPage: any;
  isLeftArrow: boolean | undefined;
  previousPageIndex: number | undefined;
  prevPageSelectedRecordIndex: number | undefined;
  hideSubmenu: boolean = false;
  private isButtonClickedSubject = new BehaviorSubject<boolean>(false);
  isButtonClicked$ = this.isButtonClickedSubject.asObservable();
  isDisplayAccordion: boolean = false;
  emptyTokenErrorShown: boolean = false;
  isParentFromChildDisableText: string = 'Add';
  selectedId: any;
  recordNumber: any;
  entityList: any;
  moduleName: string | undefined;
  selectedEntityId: string | undefined;
  //manage-provider
  isPrentProviderId: any;
  isChildId: any;
  isMakeCopy: boolean | undefined;
  isPatientId: any;
  formValue$ = new Subject<number>();
  distinctEntityIds: any[] | undefined;
  providerIds: string | undefined;
  billingGroupIds: string | undefined;
  approvalWindowEntityIds: any[] | undefined;
  private formValue = 0;
  currentPermissionModule: string | undefined;
  currentPermissionSubModule: string | undefined;
  private currentLinkSubject = new BehaviorSubject<any>(null);
  currentLink$ = this.currentLinkSubject.asObservable();
  navLinks: any;
  currentModuleName: any;
  isEntityIdRequired: boolean | undefined;
  userId: any;
  userPermissions: any;
  batchPermissions: any;
  isContainsBatch: any;
  postingCarrierPlanList: any;
  lockedLogout: boolean = false;
  visitIdDisplay: string = '';
  entityChangeTriggered: boolean = false;
  patientName: string | undefined;
  accessionNumber: string | undefined;
  searchText: string = '';
  searchFilter: string = '^[a-zA-Z0-9-_ ]*$'; // Allows only alphanumeric characters and spaces.

  //
  constructor(
    public router: Router,
    public apiService: ApiService,
    public storageService: StorageService,
    private toastr: ToastrService,
    private toast: HotToastService,
    private spinner: NgxSpinnerService,
    private deviceInfoService: DeviceDetectorService,
    //private dialog: MatDialog,
    //public rowUpdateService: RowUpdateService,
    private activatedRoute: ActivatedRoute
    //private permissionService: PermissionService
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateCurrentModuleName();
      });

    this.entityChangeTriggered = false;
  }

  public updateCurrentModuleName() {
    let route = this.activatedRoute;
    while (route.firstChild) {
      route = route.firstChild;
    }
    // Accessing the data property of the current route
    const module = route.snapshot.data['module'];
    const submodule = route.snapshot.data['submodule'];
    this.isEntityIdRequired = route.snapshot.data['isEntityIdRequired'];
    this.isContainsBatch = route.snapshot.data['isContainsBatch']!;

    this.currentPermissionModule = module ? module : '';
    this.currentPermissionSubModule = submodule ? submodule : '';
    this.userId = this.storageService.get('userId');

    if (!this.isEntityIdRequired) {
      this.selectedEntityId = "";
      sessionStorage.removeItem('entityId');
    }
    // let userToken = localStorage.getItem('token');
    // if (userToken) {
    //  // this.getPermission();
    //   //this.getMenuList(this.userId);
    // }
  }

  getCurrentModuleName(): string {
    return this.currentModuleName;
  }

  emitsidbarChangeEvent(number: boolean) {
    this.sidbarChange.emit(number);
  }

  emitrowUpdateChangeEvent(index: number) {
    this.rowUpdate.emit(index);
  }

  emitHeaderUpdate(data: any) {
    this.headerUpdate.emit(data);
  }
  public noWhitespaceValidator(control: FormControl) {
    let isWhitespace = (control.value || '').trim().length === 0;
    let isValid = !isWhitespace;
    return isValid ? null : { required: true };
  }

  logout() {
    //if (!this.lockedLogout) {
    //  this.lockedLogout = true;
    //} else {
    //  return;
    //}
    var deviceInfo = this.deviceInfoService.getDeviceInfo();
    this.apiService
      .getRequest('msme/logout', {
        deviceId: deviceInfo.userAgent,
      })
      .subscribe(
        (res) => {
          //  if(res.status){
          this.storageService.clear();
          //this.dialog.closeAll();
          this.router.navigate(['/login']);

          this.toastr.success(res.message);
          this.lockedLogout = false;
          // this.toast.success('Successful logout');
          // }else{
          //   this.toastr.error(res.message)
          //}
        },
        (err) => {
          this.storageService.clear();
          localStorage.clear();
          this.router.navigate(['/login']);
        }
      );
  }
  refreshList: EventEmitter<any> = new EventEmitter();
  notifyUpdate: EventEmitter<any> = new EventEmitter();

  ngOnInit() {
    this.selectedEntityId = sessionStorage.getItem('entityId')?.toString();
  }
  callRefresh(isRfresh = false) {
    this.refreshList.emit(isRfresh);
  }

  //  patternValidators(regex:RegExp, error:ValidationErrors):ValidatorFn{
  //   return (control:AbstractControl) : {[key:string]:any} =>{
  //     if(!control.value){
  //       return null
  //     }
  //     const valid = regex.test(control.value)

  //     return valid? null:error;
  //   }
  // }
  formatDateTime(date: any) {
    if (date) {
      return moment(date).format('MM-DD-YYYY hh:mm a');
    } else return '';
  }

  // showToast(msg: any, type: boolean) { //0: success ,1: error
  //   // type ? this.toastr.error(msg ? msg : 'Some Error Occured') : this.toastr.success(msg ? msg : 'Some Error Occured');
  //   //alert(msg);
  //   type ? this.toastr.error(msg ? msg : msg) : this.toastr.success(msg ? msg : msg);

  // }
  showToast(msg: any, type: boolean) {
    // 0: success, 1: error
    setTimeout(() => {
      type
        ? this.toastr.error(msg ? msg : 'Some Error Occurred')
        : this.toastr.success(msg ? msg : 'Some Success Message');
    });
  }

  /*Check for password match*/
  matchingPasswords(passwordKey: string, confirmPasswordKey: string) {
    return (group: FormGroup): any => {
      let password = group.controls[passwordKey];
      let confirmPassword = group.controls[confirmPasswordKey];

      if (password.value !== confirmPassword.value) {
        return {
          mismatchedPasswords: true,
        };
      }
      return null;
    };
  }

  base64ToBlob(dataURI: any) {
    // var dataURL = dataURI.toDataURL("image/jpeg");
    const byteString = atob(dataURI.toString().split(',')[1]);
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    var blob = new Blob([ab], { type: 'image/png' }); //or mimeString if you want
    var image = new File(
      [blob],
      'Logo_' + new Date().getMilliseconds() + '.png'
    );

    return image;
  }

  //showAlert(
  //  title: any,
  //  msg: any,
  //  btnTxt: any,
  //  icon: any,
  //  showCancel: any = true
  //) {
  //  return Swal.fire({
  //    title: title,
  //    text: msg,
  //    icon: icon,
  //    reverseButtons: false,
  //    showCancelButton: showCancel,
  //    confirmButtonColor: '#0d8ccd',
  //    cancelButtonColor: '#d33',
  //    confirmButtonText: btnTxt,
  //    cancelButtonText: 'No',
  //  });
  //}

  // checkDelete(slug: any) {
  //   let user = JSON.parse(this.storageService.get('user'))
  //   let permissions = this.storageService.get('permissions') ? JSON.parse(this.storageService.get('permissions')) : null;

  //   if (permissions) {
  //     var module = permissions.filter((item: any) => item.moduleSlugName == slug);
  //     if (user.role != Roles.admin)
  //       return (module.length > 0 && module[0].canDelete);
  //     else return true
  //   } else return true
  // }

  // checkView(slug: any) {
  //   let user = JSON.parse(this.storageService.get('user'))
  //   let permissions = this.storageService.get('permissions') ? JSON.parse(this.storageService.get('permissions')) : null;
  //   if (permissions) {
  //     var module = permissions.filter((item: any) => item.moduleSlugName == slug);
  //     if (user.role != Roles.admin)
  //       return (module.length > 0 && module[0].canView);
  //     else return true
  //   } else return true
  // }

  // checkEdit(slug: any) {
  //   let user = JSON.parse(this.storageService.get('user'))
  //   let permissions = this.storageService.get('permissions') ? JSON.parse(this.storageService.get('permissions')) : null;
  //   if (permissions) {
  //     var module = permissions.filter((item: any) => item.moduleSlugName == slug);
  //     if (user.role != Roles.admin)
  //       return (module.length > 0 && module[0].canEdit);
  //     else return true
  //   } else return true
  // }

  signOut() {
    this.apiService.getRequest('account/logout', {}).subscribe((res: any) => {
      if (res.status) {
        localStorage.clear();
        this.storageService.clear();

        //this.spinner.show();
        this.router.navigate(['/login']);
        this.spinner.hide();
        //this.dialog.closeAll();
        // setTimeout(()=>{
        //   this.router.navigate(['/login']);
        //   this.spinner.hide();
        // },2000);
      }
    });
  }

  rangeShouldNotBeSame(key1: string, key2: string) {
    return (group: FormGroup): any => {
      let key1Control = group.controls[key1];
      let key2Control = group.controls[key2];
      if (
        JSON.stringify(key1Control.value) == JSON.stringify(key2Control.value)
      ) {
        return {
          areSame: true,
        };
      }
      return null;
    };
  }

  public ContactDuplicateValidator(control: FormGroup) {
    let isValid = true;

    if (control) {
      let formGroup = control;
      var WorkPhone = control.value
        ? control.value.WorkPhone?.replace(/-/g, '').replace(/_/g, '')
        : formGroup
          ?.get('WorkPhone')
          ?.value.replace(/-/g, '')
          .replace(/_/g, '');
      var WorkFax = control.value
        ? control.value.WorkFax?.replace(/-/g, '').replace(/_/g, '')
        : formGroup?.get('WorkFax')?.value.replace(/-/g, '').replace(/_/g, '');
      var WorkPager = control.value
        ? control.value.WorkPager?.replace(/-/g, '').replace(/_/g, '')
        : formGroup
          ?.get('WorkPager')
          ?.value.replace(/-/g, '')
          .replace(/_/g, '');
      var WorkMobile = control.value
        ? control.value.WorkMobile?.replace(/-/g, '').replace(/_/g, '')
        : formGroup
          ?.get('WorkMobile')
          ?.value.replace(/-/g, '')
          .replace(/_/g, '');

      var ProviderPhone = control.value
        ? control.value.phone?.replace(/-/g, '').replace(/_/g, '')
        : formGroup?.get('phone')?.value.replace(/-/g, '').replace(/_/g, '');
      var ProviderFax = control.value
        ? control.value.fax?.replace(/-/g, '').replace(/_/g, '')
        : formGroup?.get('fax')?.value.replace(/-/g, '').replace(/_/g, '');

      if (
        WorkMobile &&
        WorkMobile != '' &&
        (WorkMobile == WorkPhone ||
          WorkMobile == WorkFax ||
          WorkMobile == WorkPager)
      ) {
        isValid = false;
        return isValid ? null : { duplicateMobile: true };
      } else if (
        WorkPager &&
        WorkPager != '' &&
        (WorkPager == WorkFax || WorkPager == WorkPhone)
      ) {
        isValid = false;
        return isValid ? null : { duplicatePager: true };
      } else if (WorkFax && WorkFax != '' && WorkFax == WorkPhone) {
        isValid = false;
        return isValid ? null : { duplicateFax: true };
      }

      if (ProviderFax && ProviderFax != '' && ProviderFax == ProviderPhone) {
        isValid = false;
        return isValid ? null : { duplicateFax: true };
      }
    }
    return isValid;
  }

  // checkAdd(slug: any) {
  //   let user = JSON.parse(this.storageService.get('user'))
  //   let permissions = this.storageService.get('permissions') ? JSON.parse(this.storageService.get('permissions')) : null;

  //   if (permissions) {
  //     var module = permissions.filter((item: any) => item.moduleSlugName == slug);
  //     if (user.role != Roles.admin)
  //       return (module.length > 0 && module[0].canAdd);
  //     else return true
  //   } else return true;
  // }

  hasExtension(file: any, exts: any) {
    var fileName = file.name.toLowerCase();
    return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
      fileName
    );
  }

  textPattern = "('^[a-zA-Z ]*$')";

  getPasswordValidatorMessage(passwordSetting: any) {
    let passwordErrorMessageString = 'Password must contain';
    let passwordErrorMsg = '';

    if (passwordSetting.isPasswordAlphaNumeric) {
      passwordErrorMsg += ', an Alphanumeric character';
    }
    if (passwordSetting.isPasswordContainLowerCase) {
      passwordErrorMsg += ', one lower case alphabet';
    }
    if (passwordSetting.isPasswordContainUpperCase) {
      passwordErrorMsg += ', one upper case alphabet';
    }

    if (passwordSetting.isPasswordSpecialCharactersAllowed) {
      passwordErrorMsg +=
        ", at least one of the '" +
        passwordSetting.passwordSpecialCharactersAllowed +
        "' special characters";

      //return !isPasswordValid ? { 'invalid-password' : { value: control.value } } : {};
    }
    if (!isNaN(passwordSetting.passwordMaxNumberCharacters)) {
      passwordErrorMsg +=
        `, must be less than ` +
        passwordSetting.passwordMaxNumberCharacters +
        ` characters`;
    }
    if (!isNaN(passwordSetting.passwordMinNumberCharacters)) {
      passwordErrorMsg +=
        `, must be more than ` +
        passwordSetting.passwordMinNumberCharacters +
        ` characters`;
    }

    passwordErrorMsg = passwordErrorMsg.replace(',', '');
    passwordErrorMessageString = passwordErrorMessageString + passwordErrorMsg;
    return passwordErrorMessageString;
  }

  CreateLogObject(logData: any, auditLog: any) {
    auditLog.newData = {};
    auditLog.oldData = {};
    auditLog.isEdited = false;

    logData.forEach((element: any) => {
      var newDatas = auditLog.newData;
      newDatas[element.keyName] =
        element.newData !== null ? element.newData : '';

      var oldData = auditLog.oldData;
      oldData[element.keyName] =
        element.oldData !== null ? element.oldData : '';
      //|| element.keyName == "isActive"
      if (
        element.keyName == 'isEditsPushedToEntity' ||
        element.keyName == 'entityId' ||
        element.keyName == 'optionFieldsArray' ||
        element.keyName == 'isPushedToEntity'
      ) {
        delete newDatas[element.keyName];
        delete oldData[element.keyName];
      }

      auditLog.newData = newDatas;
      auditLog.oldData = oldData;

      auditLog.isEdited = true;
    });
    return auditLog;
  }

  //facility audit log
  CreateLogObjectsFacility(logData: any, auditLog: any) {
    auditLog.newData = {};
    auditLog.oldData = {};
    auditLog.isEdited = false;

    logData.forEach((element: any) => {
      var newDatas = auditLog.newData;
      newDatas[element.keyName] =
        element.newData !== null ? element.newData : '';

      var oldData = auditLog.oldData;
      oldData[element.keyName] =
        element.oldData !== null ? element.oldData : '';

      if (
        element.keyName == 'isEditsPushedToEntity' ||
        element.keyName == 'entityId' ||
        element.keyName == 'optionFieldsArray' ||
        element.keyName == 'isPushedToEntity'
      ) {
        delete newDatas[element.keyName];
        delete oldData[element.keyName];
      }

      auditLog.newData = newDatas;
      auditLog.oldData = oldData;

      auditLog.isEdited = true;
    });

    // Check if all fields are reverted to empty, then set newData and oldData as empty objects
    if (
      Object.values(auditLog.newData).every((value) => value === '') &&
      Object.values(auditLog.oldData).every((value) => value === '')
    ) {
      auditLog.newData = {};
      auditLog.oldData = {};
      auditLog.isEdited = false;
    }

    return auditLog;
  }
  CreateSystemLogObject(logData: any, auditLog: any) {
    auditLog.newData = {};
    auditLog.oldData = {};
    auditLog.isEdited = false;

    logData.forEach((element: any) => {
      if (
        element.keyName !== 'isEditsPushedToEntity' &&
        element.keyName !== 'entityId' &&
        element.keyName !== 'isPushedToEntity' &&
        element.keyName !== 'optionFieldsArray'
      ) {
        auditLog.newData[element.keyName] = element.newData;
        auditLog.oldData[element.keyName] = element.oldData;
      }
    });

    // Check if any data was added to newData or oldData
    auditLog.isEdited =
      Object.keys(auditLog.newData).length > 0 ||
      Object.keys(auditLog.oldData).length > 0;

    return auditLog;
  }
  CreateLogObjectUser(logData: any, auditLog: any) {
    auditLog.newData = {};
    auditLog.oldData = {};
    auditLog.isEdited = false;

    logData.forEach((element: any) => {
      var newDatas = auditLog.newData;
      newDatas[element.keyName] = element.newData;

      var oldData = auditLog.oldData;
      oldData[element.keyName] = element.oldData;

      auditLog.newData = newDatas;
      auditLog.oldData = oldData;

      auditLog.isEdited = true;
    });

    // Check if newData and oldData are equal
    // if (JSON.stringify(auditLog.newData) === JSON.stringify(auditLog.oldData)) {
    //   auditLog.isEdited = false;
    // } else {
    //   auditLog.isEdited = true;
    // }

    return auditLog;
  }

  mergeJson(originalJson: any, changesJson: any) {
    // const mergedJson = { ...originalJson };

    // for (const key in changesJson) {
    //   if (changesJson.hasOwnProperty(key)) {
    //     mergedJson[key] = changesJson[key];
    //   }
    // }

    // return mergedJson;

    // Exclude isActive from both originalJson and changesJson
    const { isActive: originalIsActive, ...filteredOriginalJson } =
      originalJson;
    const { isActive: changesIsActive, ...filteredChangesJson } = changesJson;

    // Merge the filtered originalJson with the filtered changesJson
    const mergedJson = { ...filteredOriginalJson, ...filteredChangesJson };

    return mergedJson;
  }

  saveAuditLog(auditLogger: any) {
    this.apiService.postRequest('AuditLogger', auditLogger).subscribe({
      next: (n) => { },
      error: (e) => { },
    });
  }

  getSelectedRecordIndex(): number {
    return this.selectedRecordIndex;
  }
  getNextPageSelectedRecordIndex(): number {
    return 1; //this.nextPageSelectedRecordIndex;
  }
  getPreviousPageIndex(): number {
    return 1;//this.previousPageIndex;
  }
  getPrevPageSelectedRecordIndex(): number {
    return 1;//this.prevPageSelectedRecordIndex;
  }
  setSelectedRecordIndex(index: number): void {
    if (index == -1) {
      this.selectedId = 0;
    }
    this.selectedRecordIndex = index;
    this.nextPageSelectedRecordIndex = index;
    this.prevPageSelectedRecordIndex = index;
  }
  setSelectedNextRecordIndex(isLeftArrow: boolean): void {
    this.isLeftArrow = isLeftArrow;
  }
  setPreviousPageIndex(index: number): void {
    this.previousPageIndex = index;
  }

  getSelectedRecordId() {
    return this.selectedId;
  }
  setSelectedRecordId(id: any) {
    this.selectedId = id;
  }

  getRecordNumber() {
    return this.recordNumber;
  }
  setRecordNumber(recordNumber: number) {
    this.recordNumber = recordNumber;
  }

  noSpaceValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const hasSpace = /\s/.test(control.value);
      return hasSpace ? { spaceNotAllowed: true } : null;
    };
  }

  alphanumericWithSpaceValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const pattern = /^[a-zA-Z0-9\s]*$/;
      const isValid = pattern.test(control.value);
      return isValid ? null : { invalidPattern: true };
    };
  }

  setSelectedRecordPageIndex(
    index: number,
    currentPage: any,
    recordsPerPage: any
  ): void {
    var mode = this.storageService.mode;

    if (this.selectedRecordIndex + 1 > recordsPerPage && !this.isLeftArrow) {
      var pageDifference = 1;//this.previousPageIndex + 1;
      if (pageDifference == currentPage) {
        this.nextPageSelectedRecordIndex =
          ((this.selectedRecordIndex % recordsPerPage) + recordsPerPage) %
          recordsPerPage;
        this.selectedRecordIndex = this.nextPageSelectedRecordIndex;
      } else {
        this.selectedRecordIndex = -1;
      }
    } else if (
      this.selectedRecordIndex + 1 < recordsPerPage &&
      this.isLeftArrow &&
      this.selectedRecordIndex < 0
    ) {
      this.prevPageSelectedRecordIndex =
        ((this.selectedRecordIndex + recordsPerPage - 1) % recordsPerPage) + 1;
      var pageDifference = 1;// this.previousPageIndex - 1;
      if (pageDifference == currentPage) {
        this.nextPageSelectedRecordIndex =
          ((this.selectedRecordIndex + recordsPerPage - 1) % recordsPerPage) +
          1;
        this.selectedRecordIndex = this.nextPageSelectedRecordIndex;
      } else {
        this.selectedRecordIndex = -1;
      }
    } else {
      this.selectedRecordIndex = -1;
    }
  }

  onKeyPress(event: any): void {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  }

  onAlphaKeyPress(event: any): void {
    const charCode = event.which ? event.which : event.keyCode;
    if ((charCode < 65 || charCode > 90) && (charCode < 97 || charCode > 122)) {
      event.preventDefault();
    }
  }

  minMaxValidator(formGroup: FormGroup) {
    ////const minValue = formGroup.get('passwordMinNumberCharacters').value;
    ////const maxValue = formGroup.get('passwordMaxNumberCharacters').value;

    ////if (minValue && maxValue) {
    ////  if (parseInt(minValue) >= parseInt(maxValue)) {
    ////    return { minMaxError: true };
    ////  }
    //}

    return null;
  }

  validateAlphaNumericWithSpacePatternInput(inputValue: string): string {
    const pattern = /^[a-zA-Z0-9\s]*$/;
    if (!pattern.test(inputValue)) {
      // If the input value contains special characters, remove them
      return inputValue.replace(/[^a-zA-Z0-9\s]/g, '');
    }
    return inputValue;
  }

  validateAlphaNumericWithCommaAndSpaceInput(inputValue: string): string {
    const pattern = /^[a-zA-Z0-9,\s]+$/;
    if (!pattern.test(inputValue)) {
      // If the input value contains characters not matching the pattern, remove them
      return inputValue.replace(/[^a-zA-Z0-9,\s]/g, '');
    }
    return inputValue;
  }

  validateEmailPatternInput(inputValue: string): string {
    // Pattern for [a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$
    const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!pattern.test(inputValue)) {
      // If the input value does not match the pattern, remove the invalid characters
      return inputValue.replace(/[^a-zA-Z0-9._%+-@.]/g, '');
    }
    return inputValue;
  }

  formatPhoneNumber(inputValue: string): string {
    // Allow only numbers and hyphen
    inputValue = inputValue.replace(/[^0-9-]/g, '');

    // Ensure hyphens are at the correct positions
    if (inputValue.length > 3 && inputValue.charAt(3) !== '-') {
      inputValue = inputValue.slice(0, 3) + '-' + inputValue.slice(3);
    }
    if (inputValue.length > 7 && inputValue.charAt(7) !== '-') {
      inputValue = inputValue.slice(0, 7) + '-' + inputValue.slice(7);
    }

    return inputValue;
  }

  updateValidators(formGroup: FormGroup) {
    //const IsPushedToEntity = formGroup.get('isPushedToEntity').value;
    //// const isEditsPushedToEntity = formGroup.get('isEditsPushedToEntity').value;
    //const entityId = formGroup.get('entityId').value;

    //if (IsPushedToEntity != null) {
    //  if (IsPushedToEntity && (entityId?.length < 1 || entityId == null)) {
    //    return { entityRequired: true };
    //  } else if (entityId && !IsPushedToEntity) {
    //    return formGroup.get('entityId')?.setValue(null);
    //  }
    //}
    // else {
    //   if (isEditsPushedToEntity != null && !entityId) {
    //     return { entityRequired: true };
    //   } else if (entityId && isEditsPushedToEntity == null) {
    //     return formGroup.get('entityId')?.setValue(null);
    //   }
    // }
  }

  updateValidatorsMinOptions(formGroup: FormGroup) {
    //const optionFieldsArray = formGroup.get('optionFields').value;
    //var numberOfOptions = 0;
    //if (optionFieldsArray?.length == 1) {
    //  numberOfOptions = optionFieldsArray[0].value
    //    .split(',')
    //    .map((option) => option.trim())
    //    .filter(Boolean).length;
    //  if (numberOfOptions < 2) {
    //    formGroup.get('optionFields').setErrors({ minOptions: true });
    //  } else {
    //    formGroup.get('optionFields').setErrors(null);
    //  }
    //  return;
    //} else if (optionFieldsArray && optionFieldsArray.length < 2) {
    //  formGroup.get('optionFields').setErrors({ minOptions: true });
    //} else {
    //  formGroup.get('optionFields').setErrors(null);
    //}
  }

  validateInput(event: any): void {
    const inputText = event.target.value;
    const alphanumericRegex = /^[a-zA-Z0-9]+$/;

    if (!alphanumericRegex.test(inputText)) {
      // Invalid input, you can handle it accordingly, for example, prevent further processing or show an error message.
      event.target.setCustomValidity(
        'Only alphanumeric characters are allowed.'
      );
    } else {
      // Valid input
      event.target.setCustomValidity('');
    }
  }

  maxOptionsAndLengthValidator(
    maxOptions: number,
    maxLength: number
  ): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const options: string[] = control.value ? control.value.split(',') : [];
      const isValid =
        options.length <= maxOptions && options.join('').length <= maxLength;
      return isValid ? null : { maxOptionsAndLength: true };
    };
  }

  // =============== New Carousel Code =============
  getPreviousRecordIndex(
    pageIndex: number,
    actualPageSize: number,
    selectedRowIndex: number
  ) {

    this.enableAllDialogs();
    const previousRecordIndex =
      pageIndex * actualPageSize + (selectedRowIndex - 1);
    return previousRecordIndex;
  }
  getNextRecordIndex(
    pageIndex: number,
    actualPageSize: number,
    selectedRowIndex: number
  ) {

    this.enableAllDialogs();
    const nextRecordIndex = pageIndex * actualPageSize + (selectedRowIndex + 1);
    return nextRecordIndex;
  }

  getCurrentRecordIndex(
    pageIndex: number,
    actualPageSize: number,
    selectedRowIndex: number
  ) {

    this.enableAllDialogs();
    const currentIndex =
      pageIndex * actualPageSize + selectedRowIndex < 1
        ? 0
        : pageIndex * actualPageSize + selectedRowIndex;
    return currentIndex;
  }

  getKeys(data: any): string[] {
    if (data) {
      return Object?.keys(data);
    }
    return [];
  }

  toPascalCase(input: string): string {
    return input
      ?.replace(/([a-z])([A-Z])/g, '$1 $2') // Insert space between lower and upper case letters
      ?.split(' ')
      ?.map(
        (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      ?.join(' ');
  }

  formatTime(time: string): string {
    const formattedTime = moment(time, 'hh:mm A').format('HH:mm:ss');
    return formattedTime;
  }

  downloadFile(form: any, fileType: string, isGlobalEntity: boolean = false) {
    let extension: string;
    let blobType: string;

    extension = fileType;
    if (fileType == 'csv') {
      blobType = 'text/csv;charset=utf-8';
    } else {
      blobType =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    }

    var formData = {
      rowModificationIdentifier: form.rowModificationIdentifier,
      fromDate: form.fromDate,
      toDate: form.toDate,
      action: form.action,
      module: form.module,
      fileType: extension,
    };
    if (!isGlobalEntity) {
      //formData['entityId'] = this.selectedEntityId;
    }

    this.apiService
      .postRequestFile('auditlogger/download', formData)
      .then((responseMessage: any) => {
        const data: Blob = new Blob([responseMessage], {
          type: blobType,
        });
        // saveAs(data, form.module + '.' + extension);
      });
  }

  deepCompare(obj1: any, obj2: any): boolean {
    if (obj1 === obj2) {
      return true;
    }

    if (typeof obj1 !== 'object' || typeof obj2 !== 'object') {
      return obj1 === obj2;
    }

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (const key of keys1) {
      if (!this.deepCompare(obj1[key], obj2[key])) {
        return false;
      }
    }

    return true;
  }






  compareObjectsFeescheduleWithFormArray(obj1: any, obj2: any): boolean {
    if (obj1 === obj2) {
      return false;
    }

    for (const key in obj1) {
      if (typeof obj1[key] === 'object' && obj1[key] instanceof Array) {
        if (
          this.compareFeeScheduleFormArray(obj1[key], obj2[key]) ||
          this.compareFeeScheduleProcFormArray(obj1[key], obj2[key])
        ) {
          return true;
        }
      } else if (obj1[key] !== obj2[key]) {
        if (typeof obj1[key] === 'string' && typeof obj2[key] === 'string') {
          if (obj1[key].trim() !== obj2[key].trim()) {
            return true;
          }
        } else {
          return true;
        }
      }
    }

    return false;
  }

  compareObjectsVisitWithFormArray(obj1: any, obj2: any): boolean {
    if (obj1 === obj2) {
      return false;
    }

    for (const key in obj1) {
      if (typeof obj1[key] === 'object' && obj1[key] instanceof Array) {
        if (this.compareChargesFormArray(obj1[key], obj2[key])) {
          return true;
        }
      } else if (obj1[key] !== obj2[key]) {
        if (typeof obj1[key] === 'string' && typeof obj2[key] === 'string') {
          if (obj1[key].trim() !== obj2[key].trim()) {
            return true;
          }
        } else {
          return true;
        }
      }
    }

    return false;
  }

  compareChargesFormArray(formArray1: any[], formArray2: any[]): boolean {
    if (formArray1?.length !== formArray2?.length) {
      return true;
    }

    for (let i = 0; i < formArray1.length; i++) {
      const item1 = formArray1[i];
      const item2 = formArray2[i];

      if (this.areChargeItemsEqual(item1, item2)) {
        return true;
      }
    }

    return false;
  }
  areChargeItemsEqual(item1: any, item2: any): boolean {
    // Compare individual fields within each charge item
    return (
      item1.assignmentId === item2.assignmentId &&
      item1.procedureCodeId === item2.procedureCodeId &&
      item1.procedureLineItemNote === item2.procedureLineItemNote &&
      item1.authorizationNumber === item2.authorizationNumber &&
      item1.fromDateOfService === item2.fromDateOfService &&
      // ... add more fields as needed
      item1.toDateOfService === item2.toDateOfService &&
      item1.diagnosisCodeId === item2.diagnosisCodeId &&
      item1.placeOfService === item2.placeOfService &&
      item1.typeOfService === item2.typeOfService &&
      item1.units === item2.units &&
      item1.totalChargeAmount === item2.totalChargeAmount &&
      item1.dateOfCurrentIllness === item2.dateOfCurrentIllness &&
      item1.admissionDate === item2.admissionDate &&
      item1.dischargeDate === item2.dischargeDate &&
      item1.ndcCode === item2.ndcCode &&
      item1.referralNumber === item2.referralNumber &&
      item1.feeSchedule === item2.feeSchedule &&
      item1.customVisitFields === item2.customVisitFields &&
      item1.minToDOS === item2.minToDOS &&
      item1.minAdmissionDate === item2.minAdmissionDate &&
      item1.minDischargeDate === item2.minDischargeDate &&
      item1.modifier1 === item2.modifier1 &&
      item1.modifier2 === item2.modifier2 &&
      item1.modifier3 === item2.modifier3 &&
      item1.modifier4 === item2.modifier4
      // Note: Adjust this list based on the actual fields in your charge items
    );
  }

  compareFeeScheduleProcFormArray(
    formArray1: any[],
    formArray2: any[]
  ): boolean {
    if (formArray1?.length !== formArray2?.length) {
      return true;
    }

    for (let i = 0; i < formArray1.length; i++) {
      const item1 = formArray1[i];
      const item2 = formArray2[i];

      // Compare only the "id" fields of each item
      if (
        item1.procedurId !== item2.procedurId ||
        item1.procedureCode !== item2.procedureCode ||
        item1.procedureCodeDescription !== item2.procedureCodeDescription ||
        item1.perUnitChargeAmount !== item2.perUnitChargeAmount ||
        item1.allowedAmount !== item2.allowedAmount
      ) {
        return true;
      }
    }

    return false;
  }
  compareFeeScheduleFormArray(formArray1: any[], formArray2: any[]): boolean {
    if (formArray1?.length !== formArray2?.length) {
      return true;
    }

    for (let i = 0; i < formArray1.length; i++) {
      const item1 = formArray1[i];
      const item2 = formArray2[i];

      // Compare only the "id" fields of each item
      if (
        item1.assignmentId !== item2.assignmentId ||
        item1.carrierPlanId !== item2.carrierPlanId ||
        item1.carrierCategoryId !== item2.carrierCategoryId ||
        item1.providerId !== item2.providerId ||
        item1.billingGroupId !== item2.billingGroupId
      ) {
        return true;
      }
    }

    return false;
  }

  async getDDL(type: any) {
    this.apiService
      .getRequest('master/' + type, { id: this.userId })
      .subscribe((res) => {
        if (res) {
          if (type == 'entity') {
            this.entityList = res.data;

            //this.distinctEntityIds = this.storageService.get('distinctEntityIds');
            // if (this.distinctEntityIds.length < 1) {
            //   this.getPermission();
            // }
            // if (this.distinctEntityIds && this.distinctEntityIds.length > 0) {
            //   this.entityList = res.data.filter(entity => this.distinctEntityIds?.includes(entity.id));
            // }
            this.onEntityListChange.emit();
            // this.permissionSubject.next(true);
            // this.onEntityChange.next(this.selectedEntityId);
          }
        }
      });
  }

  async getPermission() {
    var id = this.storageService.get('userId');
    //    this.selectedEntityId = sessionStorage.getItem("entityId");
    if (!this.isEntityIdRequired) {
      //this.selectedEntityId = null;
    }

    var res = await firstValueFrom(
      this.apiService.getRequest('manageuser/getuserspermissions', {
        userId: id,
        module: this.currentPermissionModule,
        subModule: this.currentPermissionSubModule,
        entityId: this.selectedEntityId ? this.selectedEntityId : '',
      })
    );

    if (res.data.length > 0) {
      let permissionsList = [];
      permissionsList = res.data;
      this.userPermissions = res.data;
      //this.initializeUserPermissions(permissionsList);
      this.providerIds = res.data[0]?.providerId?.replace(/[\[\]"]/g, '') ?? '';
      this.billingGroupIds =
        res.data[0]?.billingGroupId?.replace(/[\[\]"]/g, '') ?? '';

      this.storageService.set('providerIds', this.providerIds);
      this.storageService.set('billingGroupIds', this.billingGroupIds);

      if (this.isEntityIdRequired) {
        this.distinctEntityIds = Array.from(
          new Set(permissionsList.map((item: any) => item.entityId))
        );
        const existingEntityIds = this.storageService.get('distinctEntityIds');
        // const existingRoles = this.storageService.get('userRoles');

        if (existingEntityIds === '') {
          this.storageService.set('distinctEntityIds', this.distinctEntityIds);
        }
        // if (
        //   this.commonService.distinctEntityIds &&
        //   this.commonService.distinctEntityIds.length > 0
        // ) {
        //   this.commonService.entityList = res.data.filter((entity) =>
        //     this.commonService.distinctEntityIds?.includes(entity.id)
        //   );
        // }

        if (!this.entityList && this.entityList?.length < 1) {
          this.getDDL('entity');
        }

        if (this.isContainsBatch) {
          //this.getBatchPermission(
          //  null,
          //  null,
          //  this.selectedEntityId
          //);
        }
        this.onEntityChange.next(this.selectedEntityId);
        // this.onEntityListChange.emit();
        // this.onEntityListChange.subscribe(() => {
        // this.setEntitySelection();
        // });
      }

      /* Roles to restrict self user*/
      let roles = Array.from(
        new Set(permissionsList.map((item: any) => item.role))
      );
      this.storageService.set('userRoles', roles);
      this.storageService.set('permissionsList', permissionsList);

      const filteredEntities = permissionsList.filter(
        (entity: any) => entity.isApprove === true
      );
      this.approvalWindowEntityIds = filteredEntities.map(
        (entity: any) => entity.entityId
      );
      this.storageService.set(
        'approvalWindowEntityIds',
        this.approvalWindowEntityIds
      );

      return true;
    } else {
      return false; // Handle the case when permissions data is not available
    }

    // if (res) {
    //   this.userPermissions = res.data;
    //   this.storageService.set('permissionsList', this.userPermissions);
    //   this.providerIds = res.data[0]?.providerId?.replace(/[\[\]"]/g, "") ?? "";
    //   this.billingGroupIds = res.data[0]?.billingGroupId?.replace(/[\[\]"]/g, "") ?? "";
    //   let permissionsList = [];
    //   permissionsList = res.data;
    //   this.distinctEntityIds = Array.from(
    //     new Set(
    //       permissionsList.map((item: any) => item.entityId)
    //     )
    //   );
    //   const existingEntityIds = this.storageService.get('distinctEntityIds');

    //   if (existingEntityIds === "") {
    //     // Set distinctEntityIds in storageService only if it's not already present and not null
    //     this.storageService.set('distinctEntityIds', this.distinctEntityIds);
    //   }
    // }
    //});
  }



  // ===================Part 2====================
  onApproves(element: any, reason: any) {
    //alert(element.moduleAlias)
    var approvalActon;
    if (
      element.approvalStatusId == null ||
      element.approvalStatusId == 4 ||
      element.approvalStatusId == 1
    ) {
      approvalActon = 'Level1Approval';
    } else if (element.approvalStatusId == 2) {
      approvalActon = 'Level2Approval';
    } else if (element.approvalStatusId == 3) {
      approvalActon = 'ResentToPendingTab';
    }
    const data = {
      approvalId: element.approvalId,
      approvalAction: approvalActon,
      entityRowModificationId: element.entityRowModificationId,
      moduleName: element.moduleAlias,
      entityId: element.entityId,
      reason: reason,
    };

    var apiRequest = this.apiService.postRequest(
      'approvalwindow/approve',
      data
    );

    apiRequest.subscribe({
      next: (n) => {
        // alert("approved");
        this.toastr.success(n.message);
        //this.dialog.closeAll();
        //this.rowUpdateService.emitRowUpdate();
        this.selectedId = element.entityRowModificationId;
      },
      error: (e) => { },
    });
  }
  onApprove(element: any) {
    //alert(element.moduleAlias)
    var approvalActon;
    if (
      element.approvalStatusId == null ||
      element.approvalStatusId == 4 ||
      element.approvalStatusId == 1
    ) {
      approvalActon = 'Level1Approval';
    } else if (element.approvalStatusId == 2) {
      approvalActon = 'Level2Approval';
    } else if (element.approvalStatusId == 3) {
      approvalActon = 'ResentToPendingTab';
    }
    const data = {
      approvalId: element.approvalId,
      approvalAction: approvalActon,
      entityRowModificationId: element.entityRowModificationId,
      moduleName: element.moduleAlias,
      entityId: element.entityId,
    };

    var apiRequest = this.apiService.postRequest(
      'approvalwindow/approve',
      data
    );

    apiRequest.subscribe({
      next: (n) => {
        // alert("approved");
        this.toastr.success(n.message);
        //this.dialog.closeAll();
        //this.rowUpdateService.emitRowUpdate();
        this.selectedId = element.entityRowModificationId;
      },
      error: (e) => { },
    });
  }

  onEntitySelect(event: any) {
    if (event.value && event.value !== 'Select Entity') {
      const selectedValue = event.value;
      if (
        this.selectedEntityId != selectedValue ||
        this.entityChangeTriggered == false
      ) {
        this.selectedEntityId = selectedValue;
        // localStorage.setItem('PreselectedEntityId', this.selectedEntityId);
        // sessionStorage.setItem('entityId', this.selectedEntityId);

        this.onEntityChange.next(this.selectedEntityId);
        this.entityChangeTriggered = true;
        this.getPermission();
      }
    } else if (!event.value) {
      // this.selectedEntityId = null;
    }
  }

  updateEntitySelection(entityId: any) {
    this.selectedEntityId = entityId;
    this.onEntityListChange.emit(this.entityList);
  }

  updateApprovalEntity(element: any) {
    //alert(element.moduleAlias)
    const data = {
      //MasterFileName = auditLog.ModuleName,
      entityRowModificationId: element.entityRowId,
      //MasterFileType = auditLog.IsPushedToEntity ? "Global" : "Entity",
      revisionType: 'Edited',
      masterFileEntry: element.newDataJson,
      //EntityId = auditLog.EntityId,
    };

    var apiRequest = this.apiService.updateRequest(
      'approvalwindow/update',
      data
    );

    apiRequest.subscribe({
      next: (n) => {
        // this.toastr.success(n.message);
        //this.dialog.closeAll();
        //this.rowUpdateService.emitRowUpdate();
        // this.selectedId = element.entityRowModificationId;
      },
      error: (e) => { },
    });
  }

  entityAutoApprove(element: any) {
    //alert(element.moduleAlias)

    var approvalActon = 'Level2Approval';

    const data = {
      approvalId: element.approvalId,
      approvalAction: approvalActon,
      entityRowModificationId: element.entityRowModificationId,
      moduleName: element.moduleAlias,
      entityId: this.selectedEntityId,
    };

    var apiRequest = this.apiService.updateRequest(
      'approvalwindow/updateentity',
      data
    );

    apiRequest.subscribe({
      next: (n) => {
        // alert("approved");
        //this.toastr.success(n.message);
        //this.dialog.closeAll();
        // this.rowUpdateService.emitRowUpdate();
        this.selectedId = element.entityRowModificationId;
      },
      error: (e) => { },
    });
  }

  /*Custom Patient/visit Field matChip validation*/
  // chipInputRequiredValidator(formGroup: FormGroup) {
  //   const inputType = formGroup.get('inputType').value;
  //   const optionFieldsArray = formGroup.get('optionFieldsArray');

  //   if ((inputType === 'CheckBox' || inputType === 'DropDown' || inputType === 'RadioButton') && !optionFieldsArray?.status && (optionFieldsArray?.value == '' || optionFieldsArray?.value == null)) {
  //     optionFieldsArray.setErrors({ optionsRequired: true });
  //   } else {
  //     optionFieldsArray.setErrors(null);
  //   }
  // }

  // Custom validator function
  nullOrRequiredValidator: ValidatorFn = (
    control: AbstractControl
  ): { [key: string]: any } | null => {
    if (
      control.value === null ||
      control.value === '' ||
      control.value.length < 1
    ) {
      return { required: true }; // Treat null or empty string as required
    } else {
      return null; // No validation error if the value is not null or an empty string
    }
  };

  concatValues(value: any) {
    if (Array.isArray(value)) {
      return value.map((item) => item.value).join(',');
    }
    return value;
  }

  nullIfEmpty(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;

      // If the value is empty, set it to null
      if (value === '') {
        control.setValue(null, { emitEvent: false });
      }

      return null; // Validation passed
    };
  }

  removeGuids(obj: any): any {
    if (typeof obj === 'object') {
      if (Array.isArray(obj)) {
        return obj.map((item) => this.removeGuids(item));
      } else {
        const newObj: { [key: string]: any } = {};
        for (const key in obj) {
          if (typeof obj[key] === 'string' && this.isGuid(obj[key])) {
            // Skip the key-value pair with the GUID
            continue;
          } else if (typeof obj[key] === 'boolean') {
            // Convert boolean to "Yes" or "No"
            newObj[key] = obj[key] ? 'Yes' : 'No';
          } else {
            newObj[key] = this.removeGuids(obj[key]);
          }
        }
        return newObj;
      }
    } else {
      return obj;
    }
  }

  isGuid(value: string): boolean {
    // Use a regular expression to check if the string matches the GUID pattern
    const guidPattern = /^[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
    return guidPattern.test(value);
  }
  incrementFormValue() {
    this.formValue++;
    this.formValue$.next(this.formValue);
  }

  async getMenuList(userId: any) {
    try {
      var res = await firstValueFrom(
        this.apiService.getRequest('master/getmenu', {
          userId: userId,
        })
      );

      if (res.status && res.data) {
        this.storageService.set('menu', res.data);
      } else {
        this.storageService.set('menu', []);
      }
    } catch (e) {
      console.error(e);
      this.storageService.set('menu', []);
    }
  }
  toggleContent(event: MouseEvent) {
    var target = event.target as HTMLElement;

    var parent = target.parentElement;

    var content = null; //parent.querySelector('.audit-log-content');

    if (content) {
      //content.classList.toggle('show');
    }

    // Update the button text based on the class
    //if (content.classList.contains('show')) {
    //  target.textContent = 'See Less';
    //} else {
    //  target.textContent = 'See More..';
    //}
  }

  isContentExpandable(i: number) {
    var el = document.querySelectorAll('.audit-log-content')[i] as HTMLElement;
    if (!el) return false;

    // If the content is already expanded, return false
    if (el.classList.contains('show')) return true;

    var curOverflow = el.style.overflow;

    if (!curOverflow || curOverflow === 'visible') el.style.overflow = 'hidden';

    var isOverflowing =
      el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;

    el.style.overflow = curOverflow;
    return isOverflowing;
  }

  loadFilteredData(originalArray: any[], filter: any[]) {
    return filter.length > 0
      ? filter
      : originalArray;
  }


  disableAllDialogs() {
    const dialogContainers = document.querySelectorAll('.edit');
    dialogContainers.forEach(container => {
      container.classList.add('disable-dialog');
    });
  }

  enableAllDialogs() {
    const dialogContainers = document.querySelectorAll('.edit');
    dialogContainers.forEach(container => {
      container.classList.remove('disable-dialog');
    });
  }
  onDatepickerClosed(inputElement: ElementRef): void {
    // Remove focus from the input element
    inputElement.nativeElement.blur();
  }

  // Custom validator to check if DocName is required when file is selected
  fileNameRequiredValidator(fileControl: AbstractControl): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (fileControl.value && !control.value) {
        return { 'docNameRequired': true };
      }
      return null;
    };
  }


}

